// components/common/AutoCompleteField.jsx
import React from "react";
import { Autocomplete, TextField, CircularProgress } from "@mui/material";

const AutoCompleteField = ({
  label,
  placeholder = "Select option",
  options = [],
  value,
  onChange,
  loading = false,
  getOptionLabel = (option) => option?.label || "",
  disabled = false,
  size = "small",
  variant = "outlined",
  ...props
}) => {
  return (
    <Autocomplete
      fullWidth
      size={size}
      disabled={disabled}
      value={value}
      onChange={onChange}
      options={options}
      loading={loading}
      getOptionLabel={getOptionLabel}
      {...props}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant={variant}
          placeholder={placeholder}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default AutoCompleteField;
